/*
 *@providesModule TournamentPendingModal
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {_m} from 'INTL';
import StaticWarningModal from 'StaticWarningModal';

export default class TournamentPendingModal extends React.Component {

   static propTypes = {
     modalProps: PropTypes.object,
     modalStyles: PropTypes.object,
     callback: PropTypes.func,
   }

   _getDefaultModalProps(): Object {
     const icon = 'ic_warning_exclamation.png';
     const title = _m('ACTION RESTRICTED');
     const message = _m('You are already registered for a different tournament. Please complete or cancel that match before entering another.');
     const buttonTitleArray = [_m('OK')];
     return {icon, title, message, buttonTitleArray, callback: this.props.callback};
   }

   render(): React.ReactNode {
     let modalProps = this._getDefaultModalProps();
     if (this.props.modalProps) {
       modalProps = this.props.modalProps;
     }
     return (
       <StaticWarningModal icon={modalProps.icon}
                           title={modalProps.title}
                           message={modalProps.message}
                           buttonTitleArray={modalProps.buttonTitleArray}
                           callback={modalProps.callback}/>
     );
   }
}
